import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import { routerPermission } from '@u/permission'

import '@/static/style/index.scss'
import '@/static/style/element.scss'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

routerPermission(router)

app.use(store).use(router).use(ElementPlus,{
    locale: zhCn,
  }).mount('#app')